<template lang="pug">
v-app
  section
    header.d-flex.row.flex-row.align-items-end.mb-3
      .col-8
        h1.m-0
          i Cargar usuarios
      .col-4
        .h2.text-right.ad_text-grayLight.m-0
          i.text-capitalize
    section
      .d-flex.row.flex-row.align-items-start.mt-4
        .col-12
          .card.p-0.ad_bg-gray.rounded-xl
            .card-body
              form.d-flex.flex-row.flex-wrap
                .col-6.form-group.align-items-center.mb-4
                  //- label.col-3.pl-0.m-0 Nombre
                  input(type="file" multiple :disabled="isSaving" @change="filesChange($event)" class="input-file")

          .d-flex.flex-row.mt-5
            .col-auto.stepper-button.previous
              router-link(to="/administracion/id/usuarios")
                i.material-icons
                span Volver
            button.col-auto.stepper-button.next.ml-auto(@click="Upload()")
              span Cargar
              i.material-icons
</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapActions } from 'vuex';
import { nullLiteralTypeAnnotation } from 'babel-types';
export default {
  name: 'AdministracionUsuariosMasivo',
  components: {
     Multiselect
  },
  data () {
    return {
      file: null,
      isSaving: false
    }
  },
  methods: {
    ...mapActions('user', [
      'massiveUserUpload'
    ]),
    notify(error = true, message) {
      const vm = this
      vm.$notify({
          type: error ? 'danger' : 'success',
          title: 'Notificación',
          content: message,
          closeable: true,
          duration: 5000
        })
    },
    clearInputs() {
      const vm = this
      vm.file = null;
    },
    Upload() {
      const vm = this
      vm.isSaving = true;
      const loading = vm.$toast.loading('Guardando...')
      if (vm.validate()) {
        const formData = new FormData()

        formData.append('file', this.file);

        vm.massiveUserUpload(formData).then((response) => {
          vm.isSaving = false;
          loading.hide();
          vm.$notify({
            type: 'info',
            title: 'Notificación',
            content: response,
            closeable: true,
            duration: 5000
          });
          
        })
        .catch(e => {
          loading.hide();
          console.log(e);
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: e.payload.message,
            closeable: true,
            duration: 5000
          });
        });

      } else {
        loading.hide()
      }
    },
    validate() {
      const vm = this
      let valid = true
      
      if (vm.file == null) {
        valid = false
      }

      if (valid) {
        return true
      } else {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: `Debe seleccionar un archivo a subir`,
          closeable: true,
          duration: 5000
        })
        return false
      }
    },
    filesChange(e) {
      console.log(e);
      this.file = e.target.files[0];
    }
  },
  mounted() {
    const vm = this;
    this.$emit('can-continue', { value: true })
  }
}
</script>

<style lang="css" scoped></style>


// WEBPACK FOOTER //
// src/views/administracion-usuarios-masivo.vue